/*
 Общий планировщик выравнивания высот параметров: строки складывают работу сюда, и за
 кадр она выполняется разом. Сначала у всех сбрасываются высоты, потом один раз читаются
 размеры, потом всем проставляются итоговые. Так браузер пересчитывает раскладку один раз
 на кадр, а не на каждую строку, иначе первая отрисовка большой таблицы подтормаживает.
*/

export interface ParamHeightJob {
  /** сбросить ранее проставленные высоты, чтобы взять настоящую высоту содержимого */
  clear: () => void;
  /** прочитать настоящие высоты и запомнить их у себя */
  measure: () => void;
  /** проставить итоговые высоты на строку */
  apply: () => void;
}

const pending = new Set<ParamHeightJob>();
let rafId = 0;

function flush() {
  rafId = 0;
  if (!pending.size) return;
  const jobs = Array.from(pending);
  pending.clear();
  // сначала у всех сбрасываем заданные высоты (только запись в стили)
  for (const j of jobs) j.clear();
  // потом читаем размеры. Первое чтение пересчитает раскладку один раз с учётом
  // всех сбросов, дальше идут только чтения, поэтому лишних пересчётов нет.
  for (const j of jobs) j.measure();
  // и в конце проставляем итоговые высоты
  for (const j of jobs) j.apply();
}

export function requestParamHeightAlign(job: ParamHeightJob): void {
  pending.add(job);
  if (rafId) return;
  rafId = requestAnimationFrame(flush);
}

export function cancelParamHeightAlign(job: ParamHeightJob): void {
  pending.delete(job);
}
